import { z } from 'zod';
export const DeviceStatus = z.enum(['online', 'upgrading', 'offline']);
export const DeviceKind = z.enum(['hub', 'reader', 'intercom', 'unknown']);
export const Device = z.object({
    unifi_device_id: z.string(),
    kind: DeviceKind,
    label: z.string(),
    status: DeviceStatus,
    last_heartbeat: z.string().datetime().nullable(),
    has_camera: z.boolean(),
});
export const Door = z.object({
    unifi_door_id: z.string(),
    name: z.string(),
    full_name: z.string().nullable(),
    floor_id: z.string().nullable(),
    lock_state: z.enum(['locked', 'unlocked', 'unknown']),
    position_state: z.enum(['open', 'closed', 'unknown']),
    is_bind_hub: z.boolean(),
    label_override: z.string().nullable().optional(),
});
export const UnlockBody = z.object({
    reason: z.string().min(1).max(500),
});
export const StateBody = z.object({
    state: z.enum(['locked', 'unlocked', 'hold_open']),
    reason: z.string().min(1).max(500),
});
// Lockdown is intentionally building-scoped only — tenant-scoped lockdown
// against UniFi requires per-device state changes against a verified scope
// map, and we don't have that yet (Phase 1 work). Until then the only valid
// value is 'building'.
export const LockdownBody = z.object({
    scope: z.literal('building'),
    reason: z.string().min(1).max(500),
});
//# sourceMappingURL=device.js.map